import { type SliderProps } from "@mui/material";
import { useTranslation } from "react-i18next";

import ControlledClassSlider from "./ClassSlider";

type LateThresholdSliderProps = SliderProps & { name: string };

const LateThresholdSlider = (props: LateThresholdSliderProps) => {
    const { t } = useTranslation('admin_settings');
    return (
        <ControlledClassSlider
            inputLabel={t('configuration.attendance-config.late-threshold')}
            helperText={t('configuration.attendance-config.late-threshold-hint')}
            {...props}
            min={0}
            max={60}
            step={5}
            marks={[
                { value: 5, label: '5' },
                { value: 15, label: '15' },
                { value: 30, label: '30' },
                { value: 45, label: '45' },
                { value: 60, label: '60' }
            ]}
            valueLabelDisplay="auto"
            valueLabelFormat={(value) => `${value} ${t('configuration.minutes')}`}
            getAriaLabel={(value) => `${value} ${t('configuration.minutes')}`}
        />
    );
}
export default LateThresholdSlider;